import React from "react";
import "./LinkCard.scss";
import Tooltip from "../Tooltip";

import NewTabIcon from "@/assets/icons/NewTab.svg";
import LineIcon from "@/assets/icons/line.svg";
import { useAssistantAbly } from "../../contexts/AIAssistantAblyContext";
import { openAssistantLink } from "../../utils/assistantHandoff";

const LinkCard = ({ title, description, link }) => {
    // Placeholder for future dynamic config usage
    const { conversationId } = useAssistantAbly();

    const handleExternalClick = (e) => {
        e.stopPropagation();
        openAssistantLink(link, conversationId, { event: e });
    };

    return (
        <button type="button" className="link-card" onClick={handleExternalClick}>
            <div className="left-section">
                <div className="icon-wrapper">
                    <img src={LineIcon} alt="Icon" className="icon" />
                </div>
                <div className="text-content">
                    <div className="title">{title}</div>
                    <div className="description">{description}</div>
                </div>
            </div>
            <div className="right-section">
                <Tooltip content="Open in new tab" placement="top" arrow={true} variant="light">
                    <img
                        src={NewTabIcon}
                        alt="Open in new tab"
                        className="action-icon"
                    />
                </Tooltip>
            </div>
        </button>
    );
};

export default LinkCard;
